export const reOrgConstructionMaterialCharacteristicConstants = {
	GetMaterials: {
		FAILURE : 'GET_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'GET_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	UpdateCharacteristics: {
		FAILURE : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'UPDATE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	GetFileCharacteristics: {
		FAILURE : 'GET_FILE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'GET_FILE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_FILE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	UpdateFileCharacteristics: {
		FAILURE : 'UPDATE_FILE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_FAILURE',
		REQUEST : 'UPDATE_FILE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'UPDATE_FILE_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC_SUCCESS'
	},
	CLEAR: 'CLEAR_REORG_CONSTRUCTION_MATERIAL_CHARACTERISTIC'
}